import type { Theme } from "../tokens";

/** Correspondence, set like a book. */
export const bond: Theme = {
  id: "bond",
  name: "Bond",
  thesis: "Correspondence, set like a book.",
  scheme: "light",
  colors: {
    ground: "#F7F4EC",
    surface: "#FFFDF7",
    raised: "#F2EEE2",
    ink: "#1B1A17",
    dim: "#6E6A60",
    rule: "#E2DCCD",
    lattice: "#EFEADC",
    focus: "#B4311F",
    inbox: "#B4311F",
    feed: "#3F5D52",
    paperTrail: "#6E6A60",
    screener: "#8A5A0E",
  },
  type: {
    sans: "'Source Serif 4', Georgia, serif",
    mono: "'Inter', system-ui, sans-serif",
    googleFonts: "Source+Serif+4:opsz,wght@8..60,400;8..60,600&family=Inter:wght@400;500;600",
    tracking: "0",
  },
  density: {
    row: 52,
    primary: 16,
    secondary: 15,
    meta: 13,
    listWidth: 680,
    rail: 208,
    radius: 0,
    lineHeight: 1.5,
  },
  markers: {
    inbox: "●",
    feed: "◆",
    paperTrail: "▭",
    screener: "▲",
  },
};
